import { VehicleFilterType } from "@/shared/api-contract/api-contract";

export const filterIconName = (type: VehicleFilterType): string => {
    switch (type) {
        /* case VehicleFilterType.promotion:
            return "selection"; */
        case VehicleFilterType.fueltype:
            return "fuel";
        case VehicleFilterType.firstregistrationYear:
            return "year";
        case VehicleFilterType.emissionWltp:
            return "type";
        case VehicleFilterType.emissionNedc:
            return "type";
        case VehicleFilterType.bodytype:
            return "selected";
        case VehicleFilterType.bodywork:
            return "selected";
        /* case VehicleFilterType.options:
            return "equipment"; */
        case VehicleFilterType.gearbox:
            return "gears";
        case VehicleFilterType.brand:
            return "brands";
        case VehicleFilterType.model:
            return "models";
        case VehicleFilterType.mileage:
            return "kilometers";
        case VehicleFilterType.color:
            return "color";
        case VehicleFilterType.damage:
            return "schadebedrag";
        case VehicleFilterType.advanced:
            return "gears";
        default:
            return type;
    }
};
